import { render, staticRenderFns } from "./wyModalAddSignature.vue?vue&type=template&id=72079e6d&"
import script from "./wyModalAddSignature.vue?vue&type=script&lang=js&"
export * from "./wyModalAddSignature.vue?vue&type=script&lang=js&"
import style0 from "./wyModalAddSignature.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports